<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project?batchId=' +  $route.query.batchId }">项目奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>上传材料</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card v-loading="loadings">
      <el-form :model="addForm" :rules="ruleAddForm" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForm" style="padding: 0 20px; box-sizing: border-box;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="第一完成单位名称" prop="units1" >
              <el-input size="small" maxlength="50" show-word-limit v-model.trim="addForm.units1" placeholder="请输入完成单位名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 其他完成单位 -->
        <div style="color: #606266; margin-top: 10px">其他完成单位（按照贡献度依次填写）</div>
          <div style="padding: 10px 0 10px 20px; box-sizing: border-box; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;" v-if="addForm.units2.length > 0">
            <div v-for="(item, index) in addForm.units2" :key="index" >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="单位名称" :prop="'units2.' + index + '.otherUnit'" :rules="{ required: true, message: '请输入完成单位名称', trigger: 'blur' }">
                    <div style="display: flex;">
                      <el-input size="small" maxlength="50" show-word-limit v-model.trim="item.otherUnit" placeholder="请输入完成单位名称"></el-input>
                      <div>
                        <el-button size="small" style="margin-left: 10px;" type="danger" @click="del('units2', index)">删除</el-button>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div style="margin: 15px 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('units2')">添加其他完成单位</el-button></div>
        <!-- 第一完成人 联系方式-->
        <div v-for="(item, index) in addForm.persons1" :key="index" >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :prop="'persons1.' + index + '.otherThose'" :rules="{ required: true, message: '请输入完成人姓名', trigger: 'blur' }">
                <span slot="label">
                  <span v-if="index == 0">第一</span>
                  <span v-if="index == 1">第二</span>
                  <span v-if="index == 2">第三</span>完成人
                </span>
                <el-input size="small" maxlength="20" show-word-limit v-model.trim="item.otherThose" placeholder="请输入完成人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :prop="'persons1.' + index + '.completePhones'"
              :rules="[{ required: true, message: '请输入完成人联系方式', trigger: 'blur' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                <span slot="label">
                  <span v-if="index == 0">第一</span>
                  <span v-if="index == 1">第二</span>
                  <span v-if="index == 2">第三</span>完成人联系方式
                </span>
                <el-input size="small" maxlength="11" show-word-limit v-model.trim="item.completePhones" placeholder="请输入完成人联系方式"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 其他完成人 -->
        <div style="color: #606266; margin-top: 10px">其他完成人（按照贡献度依次填写）</div>
        <div v-if="addForm.persons2.length > 0" style="padding: 10px 0 10px 20px; box-sizing: border-box; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
          <div v-for="(item, index) in addForm.persons2" :key="index" style="position: relative;">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="完成人姓名" :prop="'persons2.' + index + '.otherThose'" :rules="{ required: true, message: '请输入完成人姓名', trigger: 'blur' }">
                  <el-input size="small" maxlength="20" show-word-limit v-model.trim="item.otherThose" placeholder="请输入完成人姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="display: flex;">
                  <el-form-item style="flex: 1" label="完成人联系方式" :prop="'persons2.' + index + '.completePhones'" :rules="[{ required: true, message: '请输入完成人联系方式', trigger: 'blur' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                    <el-input size="small" maxlength="11" show-word-limit v-model.trim="item.completePhones" placeholder="请输入完成人联系方式"></el-input>
                  </el-form-item>
                  <div style="width: 70px; margin: 0 10px; padding-top: 32px;">
                    <el-button type="danger" size="small" style="width: 100%" @click="del('persons2', index)">删除</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="margin: 15px 0 30px;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('persons2')">添加其他完成人信息</el-button></div>
        <el-row :gutter="20" >
          <el-col :span="12">
            <el-form-item label="请将申报书全部内容（除项目成果研究报告）整合为一个pdf文件，文件名为项目名，加盖公章后在此上传（限pdf格式文件 100MB）" prop="declarePdfPath" class="db-lable-b">
              <el-checkbox-group v-model="addForm.declarePdfPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="100" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'declarePdfPath')" :callbackShow="addForm.declarePdfFiles"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请提交项目成果研究报告（限pdf文件 30MB）" prop="projectResultsPath" class="db-lable-b">
              <el-checkbox-group v-model="addForm.projectResultsPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'projectResultsPath')" :callbackShow="addForm.projectResultsFiles"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: center; margin: 50px 0 20px;" v-if="status == 1">
          <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
        </div>
        <!--  -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { projectMaterialReportXS, getStProjectAward, getProjectAwardBatchList } from '@/api/admin'
// import { systemUpdate, uploadFileDownload } from '@/api/system'

import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
export default {
  components: { MyUploadFilebutton },
  data() {
    return {
      // units: [
      //   { otherUnit: '', sort: 1 }
      // ],
      // persons: [
      //   { otherThose: '', completePhones: '', sort: 1 },
      //   { otherThose: '', completePhones: '', sort: 2 },
      //   { otherThose: '', completePhones: '', sort: 3 }
      // ],
      // reportPo: {
      //   phase: 0,
      //   projectAwardId: '',
      //   projectId: '',
      //   fileItems: [
      //     { type: 5, sort: 1, filePath: '申报书' },
      //     { type: 6, sort: 2, filePath: '成果报告' }
      //   ]
      // },
      status: '',
      info: {},
      loading: false,
      loadings: false,
      addForm: {
        units1: '',
        units2: [],
        persons1: [
          { otherThose: '', completePhones: '', sort: 1 },
          { otherThose: '', completePhones: '', sort: 2 },
          { otherThose: '', completePhones: '', sort: 3 }
        ],
        persons2: [],
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      ruleAddForm: {
        units1: [{ required: true, message: '请输入完成单位名称', trigger: 'blur' }],
        projectExcelPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        projectResultsPath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  created () {
    if (!this.$route.query.batchId || !this.$route.query.id) {
      this.$router.push({ path: '/project/batch' })
      return false
    }
    this.addForm.id = this.$route.query.id
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/project/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
  },
  methods: {
    submit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return this.$message.error('您还有必填项没有填写，请填写完成后再提交')
        this.$confirm('是否确定提交申报?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.addForm.units2.forEach((item, index) => {
            item.sort = index + 2
          })
          this.addForm.persons2.forEach((item, index) => {
            item.sort = index + 4
          })
          const params = {
            units: [{ otherUnit: this.addForm.units1, sort: 1 }, ...this.addForm.units2],
            persons: [...this.addForm.persons1, ...this.addForm.persons2],
            reportPo: {
              phase: 0,
              projectAwardId: this.addForm.id,
              fileItems: [
                { type: 5, filePath: this.addForm.declarePdfPath, sort: 2 },
                { type: 6, filePath: this.addForm.projectResultsPath, sort: 3 }
              ]
            }
          }
          projectMaterialReportXS(params).then(res => {
            this.loading = false
            if (res.code == '000') {
              this.$message.success('操作成功')
              setTimeout(() => {
                this.$router.replace({ path: '/project', query: { batchId: this.$route.query.batchId } })
              }, 500)
            }
          })
        })
      })
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    dtl (id) {
      this.loadings = true
      getStProjectAward({ id }).then(res => {
        this.loadings = false
        if (res.code === '000') {
          this.addForm.opinion = res.result.opinion
          this.addForm.projectName = res.result.projectName
          this.addForm.category = res.result.category
          this.addForm.projectExcelFiles = res.result.projectExcelFiles
          this.addForm.declarePdfFiles = res.result.declarePdfFiles
          this.addForm.projectResultsFiles = res.result.projectResultsFiles
          // res.result.declareWordPath = ''
          // res.result.policyProvePath = ''
          // res.result.applyProvePath = ''
          // res.result.intellectualPropertyPath = ''
          // res.result.sciTechNoveltyPath = ''
          // res.result.reportPath = ''
          // res.result.applicationPath = ''
          // if (res.result.isOwnPatent != 1) {
          //   res.result.stProjectPatents = [{ patentName: '', patentNumber: '' }]
          // }
          // this.addForm = res.result
        }
      })
    },
    add (type) {
      switch (type) {
        case 'units2':
          this.addForm[type].push({ otherUnit: '' })
          break
        case 'persons2':
          this.addForm[type].push({ otherThose: '', completePhones: '' })
          break
      }
    },
    del (type, index) {
      this.addForm[type].splice(index, 1)
    }
  }
}
</script>

<style lang="less" >
.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>

<style lang="less" scoped>
.demo-ruleForm .el-form-item {
  margin-bottom: 10px;
}
</style>
<style lang="less" >
  .el-form--label-top .el-form-item__content {
    line-height: 32px;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 32px;
  }
  .el-form--label-top .el-form-item {
    margin-bottom: 14px;
  }
</style>
